import { ReactElement, useContext } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { ListTable } from '@atom/mui';
import { UserUserGroup } from '@atom/types/userGroups';
import { setDisplayDate } from '@atom/utilities/timeUtilities';
import { getUserFullName } from '@atom/utilities/userUtilities';

import UserContext from '../UserContext';

import UserGroupsControlCell from './UserGroupsControlCell';

import classes from './groupsTab.module.css';

const { TableRow, TableCell } = ListTable;

const CONTROL_CELL_SIZE = '48px';

interface Props {
  group: UserUserGroup;
  handleRefetch: () => void;
}

const UserGroupsRow = ({ group, handleRefetch }: Props) => {
  const { user } = useContext(UserContext);
  const { defaultUserGroup } = user;
  const [, { Link }] = useNavigation();

  const displayName: ReactElement =
    defaultUserGroup?.id === group.id ? (
      <>
        {group.name} <span className={classes.tag}>Default</span>
      </>
    ) : (
      <>{group.name}</>
    );

  const path = group?.groupPath.slice(0, -1).join(' / ');

  return (
    <>
      <TableRow key={`${group.id}`}>
        <TableCell columnDisplay>
          <Link to={`/team/group/${group.id}`}>
            <div>{displayName}</div>
            <div className={classes.groupSubtext}>{path}</div>
          </Link>
        </TableCell>
        <TableCell>{getUserFullName(group.addedBy)}</TableCell>
        <TableCell>{setDisplayDate(group.addedOn)}</TableCell>
        <TableCell width={CONTROL_CELL_SIZE}>
          <UserGroupsControlCell group={group} handleRefetch={handleRefetch} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default UserGroupsRow;
